import React from "react"
import Formsy, { addValidationRule } from "formsy-react"

/* Import Local Styles */
import "./form.css"

const Form = ({
  children,
  handleValidSubmit,
  handleOnValid,
  handleOnInvalid,
  dataNetlify,
  name,
}) => {
  addValidationRule("hasValues", function (values, value) {
    if (value) {
      return value.length > 0
    } else {
      return false
    }
  })

  return dataNetlify ? (
    <Formsy
      className="formsy"
      onValidSubmit={handleValidSubmit}
      onValid={handleOnValid}
      onInvalid={handleOnInvalid}
      data-netlify={dataNetlify}
      name={name}
    >
      {children}
    </Formsy>
  ) : (
    <Formsy
      className="formsy"
      onValidSubmit={handleValidSubmit}
      onValid={handleOnValid}
      onInvalid={handleOnInvalid}
    >
      {children}
    </Formsy>
  )
}

export default Form
